export default {
  RevenueExpenseFees: '32e3f586-df52-11ee-8c67-005056beddb8',
  RevenueOther: '9d5a3738-df8d-11ee-8c67-005056beddb8',
  EstimateExpenseBusiness: 'dc31adb0-df81-11ee-8c67-005056beddb8',
  EstimateBudget: 'ffb5d5fa-db87-11ee-8c67-005056beddb8',
  EstimateInvest: 'ffb5dd16-db87-11ee-8c67-005056beddb8',
  ExpenseRegular: 'ffb5ddac-db87-11ee-8c67-005056beddb8',
  ExpenseProgram: 'ffb5de1f-db87-11ee-8c67-005056beddb8',
  ExpenseEstimateOtherByLaw: 'ffb5de8b-db87-11ee-8c67-005056beddb8',
  EstimateInvestSectorWide: '87a020e8-18aa-11ef-96b9-005056beddb8',
  ExpenseRegularSectorWide: '87a021b0-18aa-11ef-96b9-005056beddb8',
  ExpenseProgramSectorWide: '87a02231-18aa-11ef-96b9-005056beddb8',
  EstimateExpenseBusinessSectorWide: '87a022af-18aa-11ef-96b9-005056beddb8',
  RevenueExpenseFeesSectorWide: '87a02337-18aa-11ef-96b9-005056beddb8',
  ExpenseEstimateOtherByLawSectorWide: '87a023ba-18aa-11ef-96b9-005056beddb8',
  EstimateBudgetSectorWide: '87a018c4-18aa-11ef-96b9-005056beddb8',
  RevenueOtherSectorWide: '87a01f7b-18aa-11ef-96b9-005056beddb8',

  EstimateInvestArrgrate: '8d81a7fe-0d05-11ef-96b9-005056beddb8',
  ExpenseRegularArrgrate: '8d81a8c0-0d05-11ef-96b9-005056beddb8',
  ExpenseProgramArrgrate: '8d81a942-0d05-11ef-96b9-005056beddb8',

  ExpenseOtherArrgrate: '8d81aac3-0d05-11ef-96b9-005056beddb8',

  // 3 năm
  Submit3yRegular: 'cb71edca-5f59-11ef-852b-005056beddb1',
  Submit3yInvest: 'cb71edca-5f59-11ef-852b-005056beddb2',
  Submit3yProject: 'cb71edca-5f59-11ef-852b-005056beddb3',
  Submit3yBusiness: 'cb71edca-5f59-11ef-852b-005056beddb4',
  Submit3yFees: 'cb71edca-5f59-11ef-852b-005056beddb5',

  //đầu năm
  EstInitialRegular: 'c60c0151-15f0-11f0-99cc-005056b386ee',
	EstInitialExpenseBusiness :'c60c0451-15f0-11f0-99cc-005056b386ee',
	EstInitialExpenseFee:'c60c04d1-15f0-11f0-99cc-005056b386ee',
	EstInitialProject:'9478e5a3-1062-11f0-b574-005056b386ee',
	EstInitialRevenueBusiness:'c60c03e6-15f0-11f0-99cc-005056b386ee',
	EstInitialRevenueFee:'c60c0490-15f0-11f0-99cc-005056b386ee',
};
